/* fss-recent-feed.js — RECENTLY as a full feed (2026-10-01).
 *
 * Clicking "RECENTLY" (the strip's label, any of its space, or the New Arrivals module) removes the
 * small 5-item strip and shows every product newest-published first, loading more as you scroll.
 *
 *   order        published date, newest first (created date, then product id, break ties)
 *   duplicates   none — one tile per product handle, and the normal grid is hidden while the feed
 *                is up, so nothing is on the page twice
 *   loading      an IntersectionObserver sentinel adds the next batch; a "Load more" button does
 *                the same job where there is no observer, for keyboards, and if the observer never
 *                fires
 *   > 250        the homepage renders at most 250 products per Liquid page. When there are more,
 *                the remaining pages are fetched (section rendering) BEFORE sorting, so the order
 *                is still right. Products from those pages open their product page instead of the
 *                modal, because the modal's data only covers the first page.
 *   back         entering pushes "#recently"; Back leaves the feed and puts the page where it was.
 *                Coming back to "#recently" from another page restores how many tiles were loaded
 *                and the scroll position (sessionStorage, 30 minutes).
 *
 * Nothing in theme.js is changed: the feed is its own container of cloned tiles, and the open-modal
 * / star / cart handlers there are delegated, so the clones behave like the originals.
 */
(function () {
  'use strict';
  var strip = document.getElementById('recent-releases');
  var grid = document.getElementById('product-grid');
  var mainCol = document.querySelector('.fss-main-col');
  if (!strip || !grid || !mainCol) return;            /* homepage only */

  var HASH = '#recently';
  var STORE = 'fss_recent_feed';
  var KEEP_MS = 30 * 60 * 1000;
  var MAX_PAGES = 8;                                  /* 8 x 250 products */
  var meta = document.getElementById('fss-recent-feed-meta');

  var css = document.createElement('style');
  css.textContent =
    'body.fss-recent-mode #recent-releases,body.fss-recent-mode #product-grid,body.fss-recent-mode #product-grid-2col,' +
    'body.fss-recent-mode #mobile-margin-row,body.fss-recent-mode #no-products,body.fss-recent-mode .fss-main-col>.fss-marketplace-header,' +
    'body.fss-recent-mode #fss-tool-slot,body.fss-recent-mode .fss-main-col>.fss-tool-panel{display:none!important}' +
    '.fss-recent-feed{width:100%;margin-top:10px;scroll-margin-top:84px}' +
    '.fss-recent-feed[hidden]{display:none!important}' +
    '.fss-rf-head{display:flex;align-items:center;gap:12px;margin:2px 0 10px}' +
    '.fss-rf-back{font:inherit;font-weight:800;font-size:13px;line-height:1;background:var(--bg-card);color:var(--text-primary);' +
    'border:1px solid var(--border);border-radius:999px;padding:7px 14px;cursor:pointer}' +
    '.fss-rf-back:hover{background:var(--bg-card-alt)}' +
    '.fss-rf-title{font-size:12px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;color:var(--text-muted);margin:0}' +
    '.fss-rf-count{margin-left:auto;font-size:11px;color:var(--text-muted);font-variant-numeric:tabular-nums}' +
    '.fss-rf-foot{display:flex;justify-content:center;align-items:center;min-height:56px;padding:14px 0 6px}' +
    '.fss-rf-more{font:inherit;font-weight:800;font-size:13px;background:var(--bg-card);color:var(--text-primary);' +
    'border:1px solid var(--border);border-radius:999px;padding:10px 22px;cursor:pointer}' +
    '.fss-rf-more:hover{background:var(--bg-card-alt)}' +
    '.fss-rf-more[disabled]{opacity:.55;cursor:default}' +
    '.fss-rf-end{font-size:11px;letter-spacing:1px;text-transform:uppercase;color:var(--text-muted)}' +
    '.fss-rf-sentinel{height:1px;width:100%}' +
    '.fss-recent-label{cursor:pointer;display:inline-flex;align-items:center;gap:6px;background:none;border:0;padding:0;font-family:inherit}' +
    '.fss-recent-label:hover,.fss-recent-label:focus-visible{color:var(--text-primary)}' +
    '.fss-recent-label .fss-rf-chev{font-size:1.25em;line-height:.8;transform:translateY(-1px)}';
  document.head.appendChild(css);

  /* ── the container ── */
  var feed = document.createElement('div');
  feed.className = 'fss-recent-feed';
  feed.id = 'fss-recent-feed';
  feed.hidden = true;
  feed.innerHTML =
    '<div class="fss-rf-head">' +
      '<button type="button" class="fss-rf-back" aria-label="Back to the shop">&lsaquo; Back</button>' +
      '<h2 class="fss-rf-title">Recently</h2>' +
      '<span class="fss-rf-count" aria-live="polite"></span>' +
    '</div>' +
    '<div class="fss-product-grid fss-rf-grid" id="fss-rf-grid"></div>' +
    '<div class="fss-rf-foot">' +
      '<button type="button" class="fss-rf-more">Load more</button>' +
      '<span class="fss-rf-end" hidden>That&rsquo;s everything</span>' +
    '</div>' +
    '<div class="fss-rf-sentinel" aria-hidden="true"></div>';
  mainCol.insertBefore(feed, strip);
  var feedGrid = feed.querySelector('.fss-rf-grid');
  var moreBtn = feed.querySelector('.fss-rf-more');
  var endEl = feed.querySelector('.fss-rf-end');
  var countEl = feed.querySelector('.fss-rf-count');
  var sentinel = feed.querySelector('.fss-rf-sentinel');

  /* ── the list ── */
  var items = null;        /* [{handle, pub, created, id, node, remote}] sorted newest first */
  var seen = {};
  var shown = 0;
  var active = false;
  var pushed = false;      /* this page pushed the #recently entry, so Back can be history.back() */
  var preY = 0;
  var loadingPages = null;

  function num(v) { var n = parseInt(v, 10); return isNaN(n) ? 0 : n; }

  function take(card, remote) {
    var h = card.getAttribute('data-product-handle');
    if (!h || seen[h]) return;                                   /* one tile per product */
    if (card.getAttribute('data-in-margin') === 'true') return;   /* margin products live in the margin only */
    seen[h] = true;
    var created = num(card.getAttribute('data-product-created'));
    items.push({
      handle: h,
      pub: num(card.getAttribute('data-product-published')) || created,
      created: created,
      id: Number(card.getAttribute('data-product-id')) || 0,
      node: card,
      remote: !!remote
    });
  }
  function order() {
    items.sort(function (a, b) { return (b.pub - a.pub) || (b.created - a.created) || (b.id - a.id); });
  }
  function collect() {
    items = []; seen = {};
    var sel = '#product-grid .fss-product-card, #product-grid-2col .fss-product-card, #mobile-margin-row .fss-product-card';
    Array.prototype.forEach.call(document.querySelectorAll(sel), function (c) { take(c, false); });
    order();
  }

  /* More than one Liquid page of products: fetch the rest before sorting. */
  function loadRemainingPages() {
    if (loadingPages) return loadingPages;
    var next = meta && meta.getAttribute('data-next');
    var section = meta && meta.getAttribute('data-section');
    if (!next || !section || !window.fetch || !window.DOMParser) return (loadingPages = Promise.resolve());
    var pages = 0;
    function step(url) {
      if (!url || pages >= MAX_PAGES) return Promise.resolve();
      pages++;
      return fetch(url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(section), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          Array.prototype.forEach.call(doc.querySelectorAll('#product-grid .fss-product-card'), function (c) {
            take(document.importNode(c, true), true);
          });
          var m = doc.getElementById('fss-recent-feed-meta');
          return step(m && m.getAttribute('data-next'));
        });
    }
    loadingPages = step(next).then(order, function (e) {
      /* A page that will not load must not hide the products we do have. */
      if (window.console) console.warn('[recent-feed] more pages failed:', e && e.message);
      order();
    });
    return loadingPages;
  }

  function columns() {
    var w = feedGrid.getBoundingClientRect().width || window.innerWidth;
    var first = feedGrid.firstElementChild;
    if (first) {
      var cw = first.getBoundingClientRect().width;
      if (cw > 0) return Math.max(1, Math.round(w / cw));
    }
    return window.innerWidth < 600 ? 2 : 5;
  }
  function batchSize() { return Math.max(8, columns() * 4); }

  function tile(it) {
    var n = it.node.cloneNode(true);
    n.classList.remove('fss-in-recent', 'fss-row1', 'fss-row2', 'fss-first', 'fss-msel', 'fss-sold-hidden', 'fss-mobile-margin-tile');
    n.style.display = '';
    n.style.gridColumn = '';
    n.removeAttribute('data-fss-idx');
    Array.prototype.forEach.call(n.querySelectorAll('.fss-adm-dots'), function (d) { d.parentNode.removeChild(d); });
    if (it.remote) n.setAttribute('data-rf-remote', '1');
    return n;
  }

  function render(upTo) {
    if (!items) return;
    upTo = Math.min(items.length, upTo);
    var frag = document.createDocumentFragment();
    for (var i = shown; i < upTo; i++) frag.appendChild(tile(items[i]));
    feedGrid.appendChild(frag);
    shown = Math.max(shown, upTo);
    var done = shown >= items.length;
    moreBtn.hidden = done;
    endEl.hidden = !done || items.length === 0;
    countEl.textContent = items.length ? (shown + ' of ' + items.length) : 'Nothing published yet';
    save();
  }
  function more() { if (active && items && shown < items.length) render(shown + batchSize()); }

  /* ── loading more ── */
  var io = null;
  function watch() {
    if (!('IntersectionObserver' in window)) { window.addEventListener('scroll', onScrollFallback, { passive: true }); return; }
    if (io) io.disconnect();
    io = new IntersectionObserver(function (es) {
      for (var i = 0; i < es.length; i++) if (es[i].isIntersecting) { more(); break; }
    }, { rootMargin: '0px 0px 700px 0px' });
    io.observe(sentinel);
  }
  function unwatch() {
    if (io) { io.disconnect(); io = null; }
    window.removeEventListener('scroll', onScrollFallback);
  }
  var sfT = 0;
  function onScrollFallback() {
    var now = Date.now(); if (now - sfT < 120) return; sfT = now;
    if (sentinel.getBoundingClientRect().top < window.innerHeight + 700) more();
  }
  /* A batch that does not fill the screen leaves the sentinel in view with nothing to re-trigger
     the observer — keep adding until it is pushed out or the list ends. */
  function fill() {
    var guard = 0;
    while (active && items && shown < items.length && guard++ < 40 &&
           sentinel.getBoundingClientRect().top < window.innerHeight + 200) more();
  }
  moreBtn.addEventListener('click', function () { more(); });

  /* ── remembered position ── */
  var saveT = 0;
  function save() {
    if (!active) return;
    var y = window.scrollY || window.pageYOffset || 0;
    /* o = position relative to the feed's top, so a restore survives the page above it changing height */
    try { sessionStorage.setItem(STORE, JSON.stringify({ n: shown, y: y, o: Math.round(y - feedTop()), t: Date.now() })); } catch (e) {}
  }
  function saved() {
    try {
      var s = JSON.parse(sessionStorage.getItem(STORE) || 'null');
      if (s && Date.now() - s.t < KEEP_MS) return s;
    } catch (e) {}
    return null;
  }
  window.addEventListener('scroll', function () {
    if (!active) return;
    clearTimeout(saveT); saveT = setTimeout(save, 180);
  }, { passive: true });
  window.addEventListener('pagehide', save);

  function feedTop() { return feed.getBoundingClientRect().top + (window.scrollY || window.pageYOffset || 0); }
  /* Put a remembered position back, and hold it while late layout (images, the header, the cart
     bar) settles — unless the visitor has started scrolling themselves. */
  function restoreTo(r) {
    var touched = false;
    function mark() { touched = true; }
    ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (t) { window.addEventListener(t, mark, { passive: true, once: true }); });
    function put() { if (!touched && active) jump(typeof r.o === 'number' ? feedTop() + r.o : (r.y || 0)); }
    put(); setTimeout(put, 300); setTimeout(put, 900); setTimeout(put, 1800);
  }
  function jump(y) {
    /* the site has html{scroll-behavior:smooth}; a restore has to be instant */
    var de = document.documentElement, prev = de.style.scrollBehavior;
    de.style.scrollBehavior = 'auto';
    window.scrollTo(0, y);
    de.style.scrollBehavior = prev;
  }

  /* ── in / out ── */
  function enter(opts) {
    opts = opts || {};
    if (active) return;
    active = true;
    preY = window.scrollY || window.pageYOffset || 0;
    if (!items) collect();
    document.body.classList.add('fss-recent-mode');
    feed.hidden = false;
    feedGrid.innerHTML = ''; shown = 0;
    if (opts.push) {
      try { history.pushState({ fssRecent: 1 }, '', location.pathname + location.search + HASH); pushed = true; } catch (e) {}
    }
    var restore = opts.restore || null;
    var want = restore ? Math.max(restore.n || 0, batchSize()) : batchSize();
    var go = function () {
      if (!active) return;
      render(want);
      watch();
      if (restore) { restoreTo(restore); }
      else {
        /* only move the page when the feed's top is off-screen or far down it */
        var top = feed.getBoundingClientRect().top;
        if (top < 60 || top > window.innerHeight * 0.55) jump((window.scrollY || 0) + top - 84);
      }
      fill();
    };
    if (meta && meta.getAttribute('data-next')) {
      countEl.textContent = 'Loading…';
      moreBtn.disabled = true;
      loadRemainingPages().then(function () { moreBtn.disabled = false; go(); });
    } else go();
  }

  function exit(opts) {
    opts = opts || {};
    if (!active) return;
    active = false;
    unwatch();
    document.body.classList.remove('fss-recent-mode');
    feed.hidden = true;
    feedGrid.innerHTML = ''; shown = 0;
    try { sessionStorage.removeItem(STORE); } catch (e) {}
    if (opts.fixUrl && location.hash === HASH) {
      try { history.replaceState({}, '', location.pathname + location.search); } catch (e) {}
    }
    /* theme.js lays the mobile grid out from computed visibility; it was hidden, so ask again */
    try { window.dispatchEvent(new Event('resize')); } catch (e) {}
    if (opts.scroll !== false) jump(preY);
  }

  function back() {
    if (pushed && history.state && history.state.fssRecent) { history.back(); return; }   /* → popstate → exit */
    exit({ fixUrl: true });
  }
  feed.querySelector('.fss-rf-back').addEventListener('click', back);

  window.addEventListener('popstate', function () {
    if (location.hash === HASH) enter({ restore: saved() });
    else { pushed = false; exit({}); }
  });

  /* Searching or picking a category belongs to the normal grid: leave the feed, keep the scroll. */
  var searchInput = document.getElementById('search-input');
  if (searchInput) searchInput.addEventListener('focus', function () { if (active) exit({ fixUrl: true, scroll: false }); });
  document.addEventListener('click', function (e) {
    if (!active) return;
    var t = e.target;
    if (t.closest && t.closest('.fss-bubble, .fss-nav-silver, [data-mod-tag], .fss-sale-price')) exit({ fixUrl: true, scroll: false });
  }, true);

  /* Tiles from later Liquid pages have no modal data: open the product page. */
  feedGrid.addEventListener('click', function (e) {
    var card = e.target.closest && e.target.closest('.fss-product-card[data-rf-remote]');
    if (!card) return;
    if (e.target.closest('.fss-star-btn, [data-action]:not([data-action="open-modal"])')) return;
    e.preventDefault(); e.stopPropagation();
    save();
    window.location.href = '/products/' + encodeURIComponent(card.getAttribute('data-product-handle'));
  }, true);

  /* ── the way in: the RECENTLY label (and the New Arrivals module, wired in homepage.liquid) ── */
  var label = strip.querySelector('.fss-recent-label');
  if (label) {
    label.setAttribute('role', 'button');
    label.setAttribute('tabindex', '0');
    label.setAttribute('aria-label', 'Recently — show everything, newest first');
    if (!label.querySelector('.fss-rf-chev')) {
      var chev = document.createElement('span');
      chev.className = 'fss-rf-chev'; chev.setAttribute('aria-hidden', 'true'); chev.textContent = '›';
      label.appendChild(chev);
    }
    label.addEventListener('click', function () { enter({ push: true }); });
    label.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); enter({ push: true }); }
    });
  }
  window.fssOpenRecent = function () { enter({ push: true }); };
  window.fssCloseRecent = function () { back(); };
  window.fssRecentState = function () {
    return { active: active, shown: shown, total: items ? items.length : null, pushed: pushed, hash: location.hash };
  };

  /* ── arriving on #recently (Back from a product page, a reload, a shared link) ── */
  if (location.hash === HASH) {
    var s = saved();
    try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch (e) {}
    var start = function () { enter({ restore: s }); };
    if (document.readyState === 'complete') start();
    else window.addEventListener('load', start);
  }
  window.addEventListener('pageshow', function (e) {
    /* back/forward cache: the page comes back exactly as it was, nothing to rebuild */
    if (e.persisted && location.hash === HASH && !active) enter({ restore: saved() });
  });
})();
